function showSparePartsPopup() {
    document.getElementById('spare-popup-bg').style.display = 'block';
    document.getElementById('spare-popup').classList.add('show');
    document.body.style.overflow = 'hidden';
}

function spareHidePopup() {
    document.getElementById('spare-popup-bg').style.display = 'none';
    document.getElementById('spare-popup').classList.remove('show');
    document.body.style.overflow = 'scroll';
}

// Function to toggle the Add to Cart button state
function toggleSpareAddToCartButton() {
    const sparePopup = document.getElementById('spare-popup');
    if (!sparePopup) return;

    const submitButton = sparePopup.querySelector("#spare-add-to-cart");
    const checkedCheckboxes = sparePopup.querySelectorAll(".spare_product_checkbox:checked");
    submitButton.disabled = checkedCheckboxes.length === 0;
}

// Attach event listener to all checkboxes
document.querySelectorAll(".spare_product_checkbox")?.forEach((checkbox) => {
    checkbox.addEventListener("change", toggleSpareAddToCartButton);
});

const spareAddToCart = document.querySelector("#spare-add-to-cart");
var status = {
    loading: false,
};

if (spareAddToCart) {
    spareAddToCart.addEventListener("click", function (event) {
        event.preventDefault();
        if (status.loading) {
            return;
        }
        const sparePopup = document.getElementById("spare-popup");
        if (!sparePopup) return;
        const checkedCheckboxes = sparePopup.querySelectorAll(".spare_product_checkbox:checked");
        if (checkedCheckboxes.length === 0) {
            alert("Please select at least one spare part to add to the cart.");
            return;
        }
        
        const itemsToAdd = Array.from(checkedCheckboxes).map((checkbox) => {
            const parentItem = checkbox.closest(".spare_product_product-item");
            const variantSelect = parentItem.querySelector(".spare_product_variant_select");
            const selectedVariantId = variantSelect ? variantSelect.value : checkbox.dataset.id;

            return {
                id: selectedVariantId,
                quantity: parseInt(checkbox.dataset.quantity, 10) || 1,
            };
        });

        const submitButton = sparePopup.querySelector("#spare-add-to-cart");
        submitButton.classList.add("btn--loading");
        status.loading = true;

        // Use the proper method that includes section updates
        addItemsWithSectionUpdates(itemsToAdd, submitButton);
    });
}

// NEW: Proper method that includes section updates
function addItemsWithSectionUpdates(items, submitButton) {
    // First, get all the sections that need to be updated
    const sections = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { 
            bubbles: true, 
            detail: { sections: sections } 
        })
    );

    // Create form data with items and sections
    const formData = new FormData();
    
    items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
    });
    
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    // Use the theme's fetch config
    const config = {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    };

    fetch('/cart/add.js', config)
    .then(response => {
        return response.text().then(text => {
            // Try to parse as JSON regardless of status
            try {
                const data = JSON.parse(text);
                
                // If response is not OK OR if it has a status field indicating error
                if (!response.ok || data.status) {
                    const errorMessage = data.description || data.message || 'Unable to add items to cart';
                    // Show the error message immediately and stop processing
                    alert(errorMessage);
                    throw new Error('STOP_PROCESSING'); // Special error to stop the chain
                }
                
                return data;
            } catch (e) {
                if (e.message === 'STOP_PROCESSING') {
                    throw e; // Re-throw our special error
                }
                
                // If JSON parsing failed but response is OK, continue
                if (response.ok) {
                    return text;
                }
                
                // If response is not OK and JSON parsing failed
                alert('Unable to add items to cart. Please try again.');
                throw new Error('STOP_PROCESSING');
            }
        });
    })
    .then(parsedState => {
        // If we get here, the request was successful
        // Now get the full cart with updated sections
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cartJson => {
                // Combine the cart data with sections from the add response
                const updatedCart = {
                    ...cartJson,
                    sections: parsedState.sections || {}
                };
                
                return updatedCart;
            });
    })
    .then(updatedCart => {
        // Trigger the cart update with proper section data
        if (window.FoxTheme && window.FoxTheme.pubsub) {
            window.FoxTheme.pubsub.publish(
                window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, 
                { cart: updatedCart }
            );
        }

        // Clean up UI
        status.loading = false;
        submitButton.classList.remove("btn--loading");
        
        document.querySelectorAll(".spare_product_checkbox:checked").forEach((checkbox) => {
            checkbox.checked = false;
        });
        
        toggleSpareAddToCartButton();
        spareHidePopup();
    })
    .catch(error => {
        // If it's our special error, just stop processing
        if (error.message === 'STOP_PROCESSING') {
            status.loading = false;
            submitButton.classList.remove("btn--loading");
            return;
        }
        
        console.error('Error adding to cart:', error);
        status.loading = false;
        submitButton.classList.remove("btn--loading");
        
        // Show generic error only for unexpected errors
        alert('Unable to add items to cart. Please try again.');
    });
}
// Function to open cart drawer
function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
    }
}

// Listen for cart updates to ensure drawer opens
document.addEventListener('cart:updated', function(event) {
    setTimeout(openCartDrawer, 100);
});

// Close popup when clicking outside of it
document.getElementById('spare-popup-bg')?.addEventListener('click', function (event) {
    const sparePopup = document.getElementById('spare-popup');
    if (event.target === this) {
        spareHidePopup();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    toggleSpareAddToCartButton();
    
    document.querySelectorAll(".spare_product_variant_select").forEach((dropdown) => {
        dropdown.addEventListener("change", function () {
            const selectedOption = this.options[this.selectedIndex];
            const newImageUrl = selectedOption.dataset.image;
            const parentItem = this.closest(".spare_product_product-item");
            const productImage = parentItem.querySelector(".spare_product_image");
            
            if (productImage && newImageUrl) {
                productImage.src = newImageUrl;
            }
        });
    });
});